// extracted by mini-css-extract-plugin
export default {"title":"SettingsTitle_title__8yhTq","SettingsTitle":"SettingsTitle_SettingsTitle__dZhTm"};